module.exports = __webpack_public_path__ + "static/media/PushtimargImage30.5c5b2b96.jpg";